import React, { useCallback, useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import CommonService from "../../services/common.service";
import moment from "moment";

function GoodsRequested({ depo }) {
  const [activeYearly, setActiveYearly] = useState(1);
  const [checked, setChecked] = useState("0");
  const [graphData, setGraphData] = useState([]);
  const [loading, setLoading] = useState(false);

  const colors = [
    "rgba(172, 145, 228, 1)",
    "rgba(236, 137, 214, 1)",
    "rgba(88, 220, 244, 1)",
    "rgba(255, 232, 138, 1)",
  ];

  const fetchData = useCallback(() => {
    var type1 = "";

    if (checked === "0") {
      type1 = activeYearly.toString();
    } else {
      type1 = activeYearly === 1 ? "4" : activeYearly === 2 ? "5" : "6";
    }
    const req = {
      locId:
        location.pathname.includes("/centralDashboard") ||
        location.pathname === "/"
          ? "0"
          : depo,
      type: type1,
    };
    setLoading(true);

    CommonService.getGoodRequestedCount(req)
      .then((response) => {
        if (response.data) {
          setLoading(false);
          setGraphData(response.data);
        }
      })
      .catch((e) => console.log(e));
  }, [checked, activeYearly]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const location = useLocation();

  const allDatasets = Array.isArray(graphData)
    ? graphData.map((item, index) => ({
        // label: item.depo,
        label: "Request Count",
        data: item.data1.map((item) => item.amount),
        backgroundColor: colors[index],
        categoryPercentage: activeYearly === 2 ? 0.2 : 0.34,
        borderWidth: 1,
        borderColor: "white",
        borderRadius: {
          topLeft: 4,
          topRight: 4,
          bottomLeft: 4,
          bottomRight: 4,
        },
        borderSkipped: false,
      }))
    : null;

  const handleYearlyFilter = (from) => {
    setActiveYearly(from);
  };

  const generateLast7DaysData = () => {
    if (graphData.length != 0) {
      const data = graphData[0].data1.map((item) =>
        moment(item.amounttype, "YYYY-MM-DD").format("DD-MM-YY")
      );

      return data;
    } else {
      return;
    }
  };

  const generateLast7YearsData = () => {
    if (graphData.length != 0) {
      const data = graphData[0].data1.map((itm) => itm.amounttype);
      return data;
    } else {
      return;
    }
  };

  const months = Array.from({ length: dayjs().month() + 1 }, (_, i) =>
    dayjs().month(i).format("MMM")
  );

  const data =
    activeYearly === 1
      ? generateLast7DaysData()
      : activeYearly === 2
      ? months
      : activeYearly === 3
      ? generateLast7YearsData()
      : [];

  const chartData1 = {
    labels: data,
    datasets: allDatasets,
  };

  const chartData2 = {
    labels: data,
    datasets: allDatasets,
  };

  const options = {
    responsive: true,
    offset: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        border: {
          display: false,
        },
        stacked: true,
        ticks: {
          font: {
            size: 13,
            weight: "bold",
            family: "Jost",
          },
        },
      },
      y: {
        display: true,
        grid: {
          display: true,
        },

        border: {
          display: false,
        },
        stacked: true,
        title: {
          display: true,
          text: "Request Count",
        },
      },
    },
    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        display: false,
        position: "top",
        align: "end",
        labels: {
          boxWidth: 13,
          useBorderRadius: true,
          borderRadius: "6px",
        },
      },
      tooltip: {
        displayColors: true,
        yAlign: "bottom",
        backgroundColor: "rgba(254, 235, 230, 1)",
        titleColor: "black",
        bodyColor: "black",
        footerColor: "black",
        bodyFont: {
          size: 17,
          family: "Jost, sans-serif",
        },
        titleFont: {
          size: 16,
          family: "Jost, sans-serif",
        },

        // usePointStyle: true,
      },
    },
  };

  return (
    <>
      <div className="graph-header">
        <div className="graph-heading">Store Reports (Requested)</div>
        <div className="graph-yearly-filter">
          <div
            className={activeYearly === 1 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(1)}
          >
            Last 7 Days
          </div>
          <div
            className={activeYearly === 2 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(2)}
          >
            Monthly
          </div>
          <div
            className={activeYearly === 3 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(3)}
          >
            Yearly
          </div>
        </div>
        <div className="d-flex justify-content-end gap-2">
          <label class="radio-container">
            WMR
            <input
              type="radio"
              checked={checked === "0"}
              onChange={() => {
                setChecked("0");
              }}
              name="challan"
            />
            <span class="checkmark"></span>
          </label>
          <label class="radio-container">
            MTV
            <input
              type="radio"
              checked={checked === "1"}
              onChange={() => {
                setChecked("1");
              }}
              name="challan"
            />
            <span class="checkmark"></span>
          </label>
        </div>
      </div>

      {loading ? (
        <>
          <div className="loading-area">
            <div
              class="spinner-border"
              style={{ color: "rgb(247, 177, 140)" }}
              role="status"
            >
              <span class="sr-only"></span>
            </div>
            <span>Data is Loading...</span>
          </div>
        </>
      ) : graphData.length != 0 || graphData.length != 0 ? (
        <>
          <div className="mt-3">
            <Bar
              data={checked === "0" ? chartData1 : chartData2}
              options={options}
              width={600}
              height={275}
            />
          </div>
        </>
      ) : (
        <div className="text-center mt-3" style={{ height: "100%" }}>
          No Records Found{" "}
        </div>
      )}
    </>
  );
}

export default GoodsRequested;
